import React, { Component } from 'react';
import Textarea from 'react-textarea-autosize';
import format from 'date-fns/format';
import getTime from 'date-fns/get_time';

import { Mutation } from 'react-apollo';
import { UPSERT_POST_MUTATION, PERSON_QUERY } from '../graphql';
import get from 'lodash.get';

import debounce from 'lodash.debounce';

const storageKey = props => {
  const { person_id, id } = props;
  return `${person_id}:${id}`;
};

const defaultState = {
  body: '',
  date: format(new Date(), 'YYYY-MM-DDTHH:mm'),
};

export class PostForm extends Component {
  state = defaultState;

  static getDerivedStateFromProps(nextProps, prevState) {
    const { loading, error, data } = nextProps;
    if (!loading && !error && get(data, 'post.id')) {
      localStorage.removeItem(storageKey(nextProps));
      return defaultState;
    }

    // try to grab a saved note from localStorage
    const post = localStorage.getItem(storageKey(nextProps));
    if (post) {
      try {
        return JSON.parse(post);
      } catch (e) {
        console.error(e);
        return null;
      }
    }

    return null;
  }

  save = debounce(() => {
    console.log('saving');
    const { body, date } = this.state;
    localStorage.setItem(
      storageKey(this.props),
      JSON.stringify({ body, date })
    );
  }, 200);

  render() {
    const { upsertPost, loading, error, data } = this.props;

    const { person_id, id } = this.props;
    const { body, date } = this.state;

    return (
      <form
        className="card"
        onSubmit={async e => {
          e.preventDefault();

          upsertPost({
            person_id,
            id,
            body,
            date: getTime(date),
          });
        }}
      >
        <fieldset disabled={loading}>
          <div className="card-header">
            <div className="form-row">
              <div className="col">
                <input
                  type="datetime-local"
                  className="form-control"
                  value={date}
                  onChange={e =>
                    this.setState({ date: e.target.value }, this.save)
                  }
                />
              </div>
              <div className="col">
                <button
                  type="submit"
                  className="btn btn-outline-primary float-right"
                >
                  create note
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <Textarea
              className={`form-control ${error ? 'is-invalid' : ''}`}
              minRows={3}
              value={body}
              onChange={e => this.setState({ body: e.target.value }, this.save)}
            />
            <div className="invalid-feedback">{get(error, 'message')}</div>
          </div>

          {false && (
            <pre>
              {JSON.stringify(
                {
                  props: this.props,
                  state: this.state,
                  storageKey: storageKey(this.props),
                },
                null,
                2
              )}
            </pre>
          )}
        </fieldset>
      </form>
    );
  }
}

export default props => (
  <Mutation mutation={UPSERT_POST_MUTATION}>
    {(upsertPost, { loading, error, data }) => (
      <PostForm
        {...props}
        upsertPost={post => {
          upsertPost({
            variables: post,
            // this works but is unnecessary with update?
            // refetchQueries: props.refetchQueries,
            // optimisticResponse: {
            //   __typename: 'Mutation',
            //   post: {
            //     id: -1,
            //     created_at: new Date(),
            //     updated_at: new Date(),
            //     date: new Date(),
            //     body: 'optimistic body',
            //     __typename: 'Post',
            //   },
            // },
            update: (store, { data: { post } }) => {
              // this feels so gross
              const data = store.readQuery({
                query: PERSON_QUERY,
                variables: { id: props.person_id },
              });
              data.person.posts.unshift(post);
              store.writeQuery({
                query: PERSON_QUERY,
                variables: { id: props.person_id },
                data,
              });
            },
          });
        }}
        loading={loading}
        error={error}
        data={data}
      />
    )}
  </Mutation>
);



// WEBPACK FOOTER //
// ./src/components/PostForm.js